<template>
	<div class="d-flex align-items-center" style="min-width:0;">
		<i
			class="me-1 flex-shrink-0"
			:class="[icona, troncato ? 'text-warning' : 'text-muted']"
			:style="{ cursor: troncato ? 'pointer' : 'default' }"
			@click.stop="troncato && (espanso = !espanso)"
		></i><span ref="testo" :class="espanso ? '' : 'text-truncate'" :style="{ minWidth: 0, whiteSpace: espanso ? 'normal' : null }">{{ testo }}</span>
	</div>
</template>

<script>
// Stesso comportamento del titolo in VoceNode: icona gialla e cliccabile solo se il testo sfora
export default {
	name: "TestoEspandibile",

	props: {
		testo: { type: String, default: '' },
		icona: { type: String, default: 'ph-file-text' },
	},

	data() {
		return {
			troncato: false,
			espanso: false,
		}
	},

	watch: {
		testo() {
			this.$nextTick(this.checkTroncato);
		},
	},

	mounted() {
		this.observer = new ResizeObserver(() => this.checkTroncato());
		this.observer.observe(this.$refs.testo);
	},

	beforeUnmount() {
		this.observer.disconnect();
	},

	methods: {
		checkTroncato() {
			if (this.espanso) return;
			const el = this.$refs.testo;
			this.troncato = !!el && el.scrollWidth > el.clientWidth;
		},
	},
}
</script>
